module.exports = __webpack_public_path__ + "img/log-manager-clears.ac0e8262.png";